const state = {
  isMobile: false,
  screenWidth: 0,
  screenHeight: 0,
  smallScreen: false,
  currentScroll: 0,
  lightTheme: false,
  lightBackground: false,
  hiddenMenu: false,
}
const getters = {}

const mutations = {
  SET_IS_MOBILE: (state, payload) => state.isMobile = payload,
  SET_SCREEN_WIDTH: (state, payload) => state.screenWidth = payload,
  SET_SCREEN_HEIGHT: (state, payload) => state.screenHeight = payload,
  SET_SMALL_SCREEN: (state, payload) => state.smallScreen = payload,
  SET_CURRENT_SCROLL: (state, payload) => state.currentScroll = payload,
  SET_LIGHT_THEME: (state, payload) => state.lightTheme = state.lightBackground = payload,
  SET_LIGHT_BACKGROUND: (state, isLight) => state.lightBackground = isLight,
  SET_HIDDEN_MENU: (state, current) => state.hiddenMenu = current,
}

const actions = {}

export default{
    state,getters,mutations,actions
}
